export default __webpack_public_path__ + "assets/webgl/occlus.283fa8ef.jpg";